import { render, staticRenderFns } from "./Foot.vue?vue&type=template&id=5560511c&scoped=true&"
var script = {}
import style0 from "./Foot.vue?vue&type=style&index=0&id=5560511c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5560511c",
  null
  
)

export default component.exports